import { gql } from '@apollo/client';

export const SINGLE_COMMENT = gql`
  query singleComment($author: String!, $permlink: String!) {
    singleComment(author: $author, permlink: $permlink) {
      _id
      rootAuthor
      rootPermlink
      rootTitle
      rootId
      createdAt
      author {
        username
        displayName
        avatar
        roles
      }
      parentAuthor
      parentPermlink
      permlink
      body
      parentId
      depth
    }
  }
`;

export const COMMENT_QUERY = gql`
  query comments($rootId: String) {
    comments(rootId: $rootId) {
      _id
      rootAuthor
      rootPermlink
      rootTitle
      rootId
      createdAt
      author {
        username
        displayName
        avatar
        roles
      }
      permlink
      body
      parentId
      depth
    }
  }
`;

export const USER_COMMENT_QUERY = gql`
  query userComments(
    $parentAuthor: String
    $author: String
    $excludeAuthor: String
    $limit: Int!
    $offset: Int!
    $onlyUnread: Boolean
  ) {
    userComments(
      parentAuthor: $parentAuthor
      author: $author
      excludeAuthor: $excludeAuthor
      limit: $limit
      offset: $offset
      onlyUnread: $onlyUnread
    ) {
      isRead
      _id
      depth
      createdAt
      author {
        username
        displayName
        avatar
      }
      permlink
      body
      parentAuthor
      parentPermlink
      rootAuthor
      rootPermlink
      rootTitle
      rootId
      isFlagged
    }
  }
`;

export const MARK_COMMENT_AS_READ = gql`
  mutation markCommentAsRead($id: String!) {
    markCommentAsRead(id: $id) {
      success
      message
    }
  }
`;

export const DELETE_COMMENT = gql`
  mutation deleteComment($permlink: String!, $author: String) {
    deleteComment(permlink: $permlink, author: $author) {
      success
      message
    }
  }
`;
